import type { AppSettings } from '@kelan-ui/vue/settings'

type RouteMode = NonNullable<AppSettings['routeMode']>

export const WE_COM_SCHEDULE_BOARD_PATH = '/wecom/schedule-board'

export function shouldUseHtml5History(pathname: string, routeMode: RouteMode): boolean {
  return routeMode === 'html5' || pathname === WE_COM_SCHEDULE_BOARD_PATH
}
